// DSS Documentation on SocoSystemMessageComponent - http://tiny.sc/cgsocosystemmessagecomponent
import { Component, Input, OnInit } from '@angular/core';

export enum SocoSystemMessageType {
    Unknown = 0,
    Loading = 1,
    NoResults = 2,
    Error = 3,
    AccessDenied = 4
}
@Component({
    selector: 'soco-system-message',
    template: `<div class="soco-system-message">
                    <i class="{{icon}}"></i>
                    <h2>{{message}}</h2>
                </div>`
})
export class SocoSystemMessageComponent implements OnInit {
    @Input() message: string = null;
    @Input() icon: string = null;
    @Input() messageType: string = SocoSystemMessageType[SocoSystemMessageType.Unknown];

    ngOnInit(): void {
        switch (SocoSystemMessageType[this.messageType]) {
            case SocoSystemMessageType.Loading:
                if (!this.message) {
                    this.message = 'Loading...';
                }
                if (!this.icon) {
                    this.icon = 'fa-spinner fa-5x fa-spin';
                }
                break;
            case SocoSystemMessageType.NoResults:
                if (!this.message) {
                    this.message = 'No results found';
                }
                if (!this.icon) {
                    this.icon = 'fa-ban fa-5x';
                }
                break;
            case SocoSystemMessageType.Error:
                if (!this.message) {
                    this.message = 'Oops! An error occurred processing your request.If the problem persists contact the IT Help Desk.';
                }
                if (!this.icon) {
                    this.icon = 'fa-exclamation-triangle fa-5x';
                }
                break;
            case SocoSystemMessageType.AccessDenied:
                if (!this.message) {
                    this.message = 'Access Denied';
                }
                if (!this.icon) {
                    this.icon = 'fa-ban fa-5x';
                }
                break;
        }
    }
}


